import { Component } from '@theme/component';
import { bindOverflowCarousel } from '@theme/bt-scroll-carousel';

/**
 * Bo+Tee Category Carousel — overflow-x track via `@theme/bt-scroll-carousel`.
 *
 * @extends {Component}
 */
class BtCategoryCarousel extends Component {
  /** @type {import('./bt-scroll-carousel').OverflowCarouselBinding | null} */
  #carousel = null;

  connectedCallback() {
    super.connectedCallback();
    const track = this.querySelector('[data-bt-cc-track]');
    this.#carousel = bindOverflowCarousel({
      root: this,
      track: track instanceof HTMLElement ? track : null,
      prevButton: this.querySelector('[data-bt-cc-prev]'),
      nextButton: this.querySelector('[data-bt-cc-next]'),
      cardSelector: '.bt-cc__card',
      progressVar: '--bt-cc-progress',
      features: { progress: true, nav: true },
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#carousel?.disconnect();
    this.#carousel = null;
  }
}

if (!customElements.get('bt-category-carousel')) {
  customElements.define('bt-category-carousel', BtCategoryCarousel);
}
